/**
 * Email change API client
 */
import client from './client';

export interface EmailChangeStatus {
  has_pending_change: boolean;
  pending_email: string | null;
  has_payment_method: boolean;
}

export interface EmailChangeInitiateResponse {
  message: string;
  has_payment_method: boolean;
}

export interface EmailChangeVerifyResponse {
  message: string;
}

/**
 * Get current email change status
 */
export async function getEmailChangeStatus(): Promise<EmailChangeStatus> {
  const response = await client.get('/api/auth/change-email/status');
  return response.data;
}

/**
 * Initiate email change - sends verification to current email
 */
export async function initiateEmailChange(
  newEmail: string,
  password: string
): Promise<EmailChangeInitiateResponse> {
  const response = await client.post('/api/auth/change-email/initiate', {
    new_email: newEmail,
    password,
  });
  return response.data;
}

/**
 * Verify email change with token from email
 */
export async function verifyEmailChange(token: string): Promise<EmailChangeVerifyResponse> {
  const response = await client.post('/api/auth/change-email/verify', {
    token,
  });
  return response.data;
}

/**
 * Verify email change with card last 4 digits (fallback method)
 */
export async function verifyEmailChangeWithCard(
  cardLast4: string
): Promise<EmailChangeVerifyResponse> {
  const response = await client.post('/api/auth/change-email/verify-card', {
    card_last4: cardLast4,
  });
  return response.data;
}
